export const offices = [
  {
    title: 'Головной офис',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland-v2.svg',
        country: 'Польша',
        city: 'Варшава',
      },
    ],
  },
  {
    title: 'Центры разработки',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/poland-v2.svg',
        country: 'Польша',
        mobileCountry: 'PL',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Lithuania.svg',
        country: 'Литва',
        mobileCountry: 'LT',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/hungary.svg',
        country: 'Венгрия',
        mobileCountry: 'HU',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Georgia-v2.svg',
        country: 'Грузия',
        mobileCountry: 'GE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/kazakhstan.svg',
        country: 'Казахстан',
        mobileCountry: 'KZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/azerbaijan.svg',
        country: 'Азербайджан',
        mobileCountry: 'AZ',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Germany.svg',
        country: 'Германия',
        mobileCountry: 'DE',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/india-v2.svg',
        country: 'Индия',
        mobileCountry: 'IN',
      },
    ],
  },
  {
    title: 'Бизнес-представительства',
    items: [
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-kingdom-v2.svg',
        country: 'Великобритания',
        mobileCountry: 'GB',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/United-states-of-america-v2.svg',
        country: 'США',
        mobileCountry: 'US',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Cyprus.svg',
        country: 'Кипр',
        mobileCountry: 'CY',
      },
      {
        flag: 'https://content.andersenlab.com/common-data/flags/oman/1760026800.svg',
        country: 'Оман',
        mobileCountry: 'OM',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/Saudi_Arabia.svg',
        country: 'КСА',
        mobileCountry: 'SA',
      },
      {
        flag: 'https://static.andersenlab.com/andersenlab/new-andersensite/icons/countries-flags/UAE-v2.svg',
        country: 'ОАЭ',
        mobileCountry: 'AE',
      },
    ],
  },
];
